import React from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import TestAccessCodeForm from '@/components/TestAccessCodeForm'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { KeyRound } from 'lucide-react'

const TestAccess = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-1 container mx-auto px-4 py-12">
        <div className="max-w-md mx-auto">
          <Card className="border-none shadow-none mb-8">
            <CardHeader className="text-center">
              <div className="mx-auto mb-4 bg-primary/10 p-4 rounded-full w-16 h-16 flex items-center justify-center">
                <KeyRound className="h-8 w-8 text-primary" />
              </div>
              <CardTitle className="text-2xl">Sınav Erişimi</CardTitle>
              <CardDescription>
                Yöneticinizden aldığınız benzersiz erişim kodu ile sınava başlayabilirsiniz.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <TestAccessCodeForm />
            </CardContent>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default TestAccess
